import { __assign, __awaiter, __generator, __values } from "tslib";
import * as Sentry from "@sentry/react";
import isEmpty from "lodash/isEmpty";
import { clearJwt, getJwt, setJwt } from "./jwt";
import { GLOBAL_CONSTANTS } from "../constants";
import { CustomError } from "../utils/customError";
import { getTracingId } from "../utils/getUniqueValue";
var BASE_URL = GLOBAL_CONSTANTS.BACKEND_API;
var extractJson = function (res) {
    return res
        .text()
        .then(function (text) {
        try {
            return JSON.parse(text);
        }
        catch (_a) {
            return text;
        }
    })
        .catch(function () { return new Promise(function (resolve) { return resolve(null); }); });
};
var getData = function (res, emptyResponse) {
    return emptyResponse ? new Promise(function (resolve) { return resolve(null); }) : extractJson(res);
};
var parseStatus = function (res, emptyResponse) {
    return new Promise(function (resolve, reject) {
        var e_1, _a;
        if (res.ok) {
            var headers = res.headers;
            var data = getData(res, emptyResponse);
            if (headers) {
                var headerEntries = headers.entries();
                var authHeader = null;
                try {
                    for (var headerEntries_1 = __values(headerEntries), headerEntries_1_1 = headerEntries_1.next(); !headerEntries_1_1.done; headerEntries_1_1 = headerEntries_1.next()) {
                        var pair = headerEntries_1_1.value;
                        if (pair[0] === "authorization") {
                            authHeader = pair[1];
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (headerEntries_1_1 && !headerEntries_1_1.done && (_a = headerEntries_1.return)) _a.call(headerEntries_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                if (typeof authHeader === "string" && authHeader.length) {
                    var authHeaderData = authHeader.split(" ");
                    if (authHeaderData[0] === "Bearer") {
                        setJwt(authHeaderData[1], "", authHeaderData[2]);
                    }
                }
            }
            data.then(function (r) { return resolve(r); });
        }
        else {
            if (res.status === 401) {
                clearJwt();
                window.location.pathname = "/signIn";
                reject({ code: res.status, response: { message: "Unauthorized" } });
            }
            var data = getData(res, emptyResponse);
            data.then(function (response) { return reject({ code: res.status, response: response }); });
        }
    });
};
export var request = function (url, method, body, options, skipToken, emptyResponse, additionalHeader) {
    var _a;
    if (method === void 0) { method = "GET"; }
    if (skipToken === void 0) { skipToken = false; }
    if (emptyResponse === void 0) { emptyResponse = false; }
    return __awaiter(this, void 0, void 0, function () {
        var reqOptions, useBaseUrl, validUrl, finalUrl, res, e_2, error, err, code;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    reqOptions = __assign({ method: method, headers: requestHeaders(skipToken, additionalHeader), body: method !== "GET" ? (body instanceof File ? body : JSON.stringify(body)) : null, credentials: "include" }, options);
                    useBaseUrl = true;
                    try {
                        validUrl = new URL(url);
                        if (validUrl)
                            useBaseUrl = false;
                    }
                    catch (_c) { }
                    finalUrl = "".concat(useBaseUrl ? BASE_URL : "").concat(url);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4, fetch("".concat(finalUrl).concat(finalUrl.match(/\?/) ? "&" : "?", "_=").concat(new Date().valueOf()), reqOptions)];
                case 2:
                    res = _b.sent();
                    return [4, parseStatus(res, emptyResponse)];
                case 3: return [2, _b.sent()];
                case 4:
                    e_2 = _b.sent();
                    error = e_2;
                    err = ((_a = error.response) === null || _a === void 0 ? void 0 : _a.message) || error.message || "Something went wrong...";
                    code = e_2.code;
                    if (!(e_2 instanceof CustomError) && code !== 404 && code !== 422) {
                        Sentry.captureException(new Error(err), {
                            level: "error",
                            extra: {
                                message: err,
                                status: e_2.code,
                                url: finalUrl,
                                requestOpts: reqOptions
                            },
                            tags: { type: "api" }
                        });
                    }
                    throw new CustomError(err, e_2.code);
                case 5: return [2];
            }
        });
    });
};
export var requestHeaders = function (skipToken, additionalHeader) {
    if (skipToken === void 0) { skipToken = false; }
    if (additionalHeader === void 0) { additionalHeader = {}; }
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("tracing-number", getTracingId());
    if (!isEmpty(additionalHeader)) {
        for (var key in additionalHeader) {
            headers.append("".concat(key), "".concat(additionalHeader[key]));
        }
    }
    if (!skipToken) {
        var token = getJwt();
        headers.append("Authorization", "Bearer ".concat(token));
    }
    return headers;
};
//# sourceMappingURL=request.js.map